module.exports = "/_next/static/images/star1light-cce4637ef0486a80dbdbd677bdd622c6.svg";